import React from 'react';
import { Flame, Clock, Loader2 } from 'lucide-react';

const UserSummary = () => {
  const userName = 'John';

  return (
    <aside className="user-summary panel">
      <div className="user-greeting">Hi {userName}!</div>

      <div className="user-summary-stack">
        <div className="summary-card streak-card">
          <div className="summary-card-icon">
            <Flame size={36} />
          </div>
          <div className="summary-card-content">
            <div className="summary-value">300</div>
            <div className="summary-sub">Days</div>
          </div>
        </div>

        <div className="summary-card hours-card">
          <div className="summary-card-icon hours">
            <Clock size={28} />
          </div>
          <div className="summary-card-content">
            <div className="summary-value small">6</div>
            <div className="summary-sub">hrs a week</div>
          </div>
        </div>

        <div className="summary-card focus-card">
          <div className="summary-card-icon focus">
            <Loader2 size={28} className="spinning" />
          </div>
          <div className="summary-card-content">
            <div className="summary-sub">Focus Timer</div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default UserSummary;
